import { jsx as u } from "react/jsx-runtime";
import { forwardRef as c, useCallback as f } from "react";
import o from "./styles.module.less.js";
const i = c((e, n) => {
  var t;
  const { value: s = "", disabled: a, onChange: r, error: l } = e, m = f((p) => {
    a || r(p.target.value);
  }, [a, r]);
  return /* @__PURE__ */ u(
    "textarea",
    {
      ref: n,
      ...e.props,
      className: `${o.textareaInput} ${(t = e.props) == null ? void 0 : t.className} ${l ? o.error : ""}`,
      onChange: m,
      disabled: a,
      value: s
    }
  );
});
i.displayName = "TextareaInput";
export {
  i as TextareaInput
};
